import { Mesh, PlaneGeometry, MeshBasicMaterial, CanvasTexture, DoubleSide } from 'three';

class Text2D extends Mesh {
  constructor(text, font, color, offset, anchor) {
    // Create canvas and draw text
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 512;
    canvas.height = 128;

    ctx.font = font || '200px Arial';
    ctx.fillStyle = typeof color === 'number'
      ? '#' + color.toString(16).padStart(6, '0')
      : (color || '#999999');
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillText(text || '', canvas.width / 2, canvas.height / 2);

    const texture = new CanvasTexture(canvas);
    texture.needsUpdate = true;

    const material = new MeshBasicMaterial({
      map: texture,
      transparent: true,
      side: DoubleSide,
      depthTest: true,
      depthWrite: false,
    });

    const geometry = new PlaneGeometry(1, 0.25);
    super(geometry, material);

    this._canvas = canvas;
    this._ctx = ctx;
    this._texture = texture;
    this._font = font || '200px Arial';
    this._color = ctx.fillStyle;

    this.renderOrder = 1000000;
  }

  set text(str) {
    const ctx = this._ctx;
    ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
    ctx.font = this._font;
    ctx.fillStyle = this._color;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.fillText(str || '', this._canvas.width / 2, this._canvas.height / 2);
    this._texture.needsUpdate = true;
  }

  get text() {
    return '';
  }

  set size(s) {
    this.scale.setScalar(s);
  }

  get size() {
    return this.scale.x;
  }
}

export { Text2D };
